import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AppGuard } from "./core/guards/app.guard";
import { LanguageGuard } from "./core/guards/language.guard";
import { LoginGuard } from "./core/guards/login.guard";
import { MsalServicesComponent, MsalGuard } from '@cemex-core/msal-services-v1';
import { AuthFactoryGuard } from '@core/guards/app-factory.guard'

const routes: Routes = [
  {
    path: "login",
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule),
    canActivate: [LoginGuard],
  },
  { path: 'login/auth', component: MsalServicesComponent, canActivate: [MsalGuard] },
  {
    path: "invoices-payments",
    loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
    canActivateChild: [AuthFactoryGuard, LanguageGuard],
  },
  {
    path: "invoices-payments/document-center",
    loadChildren: () => import('./components/documentCenter/documentCenter.module').then(m => m.DocumentCenterModule),
    data: { isPublic: true },
    canActivateChild: [AuthFactoryGuard, LanguageGuard],
  },
  {
    path: "invoices-payments/redirect",
    loadChildren: () => import('./components/redirect/redirect.module').then(m => m.RedirectModule),
    data: { isPublic: true, skipGuard: true },
  },
  { path: "**", redirectTo: "invoices-payments/error#not-found" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AppGuard, LanguageGuard, LoginGuard, MsalGuard, AuthFactoryGuard ],
})
export class AppRoutingModule {
  constructor() {}
}
